import React, { Component } from "react";
import { Segment, List, Icon } from "semantic-ui-react";
import _ from "lodash";
import "../../assets/styles/main.css";

class ReportSummary extends Component {
  componentDidMount() {}

  handleClick = (e, index) => {
    this.props.onReportIndexChanged(index);
  };

  render() {
    const list = [];
    if (this.props.itemTitles !== undefined) {
      _.forEach(this.props.itemTitles, (title, index) => {
        list.push(
          <List.Item
            key={`report_item_${index}`}
            className={`report-list-item ${
              this.props.activeSummaryIndex === index ? "link-highlight" : ""
            }`}
            onClick={() => this.handleClick(this, index)}
          >
            <Icon name="checkmark" className={"no-underline"} />
            {title}
          </List.Item>
        );
      });
    } else {
      _.forEach(this.props.records, (rec, index) => {
        const name = rec;
        let fullName = "";
        if (name !== undefined) {
          fullName = `${name.firstName[0]._} ${_.get(
            name,
            "middleName[0]._",
            ""
          )} ${name.lastName[0]._}`;
        }
        list.push(
          <List.Item
            key={`report_item_${index}`}
            className={`report-list-item ${
              this.props.activeSummaryIndex === index ? "link-highlight" : ""
            }`}
            onClick={() => this.handleClick(this, index)}
          >
            <Icon name="checkmark" className={"no-underline"} />
            {fullName}
          </List.Item>
        );
      });
    }
    return (
      <Segment>
        <List>
          <List.Header className={"report-summary"}>
            {this.props.title ? this.props.title : "Subjects in this report"}
          </List.Header>
          {list}
        </List>
      </Segment>
    );
  }
}

export default ReportSummary;



// WEBPACK FOOTER //
// ./src/components/reports/ReportSummary.js